import { useEffect, useState } from 'react';

const getPermissions = async (): Promise<PermissionType[]> => {
  return ['admin'];
};

export const useSetPermissions = (loading: boolean, onRelogin: () => void) => {
  const [inited, setInited] = useState(false);
  const [permissions, setPermissions] = useState<PermissionType[]>([]);

  useEffect(
    () => {
      if (loading) return;

      let ignore = false;

      const processUserInfo = async () => {
        try {
          const response = await getPermissions();

          if (ignore) return;

          setPermissions(response);
          setInited(true);
        } catch {
          if (ignore) return;

          setPermissions([]);
          setInited(false);
          onRelogin?.();
        }
      };

      processUserInfo();

      return () => {
        ignore = true;
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [loading]
  );

  return { inited, permissions: permissions };
};
